import * as Actions from './actions';
import * as States from '../../request-states';

const init = {
	fetchState: States.IDLE
}

export default function reducer (state=init, action) {
	switch (action.type) {
		case Actions.FETCH_ACCESS_REPORTS_START:
			return {
				...state,
				fetchState: States.LOADING,
			}
		case Actions.FETCH_ACCESS_REPORTS_SUCCESS:
			return {
				...state,
				fetchState: States.SUCCESS,
			}
		case Actions.FETCH_ACCESS_REPORTS_FAIL:
			return {
				...state,
				fetchState: States.FAIL,
				error: action.error
			}
		case Actions.SET_ACCESS_REPORTS:
			return {
				...state,
				report: action.accessReports,
			}
		case Actions.RESET_ACCESS_REPORTS:
			return Object.assign({}, init);
		default:
			return state;
	}
}